import { z } from "zod";
import { telemetryDataProviderSchema } from "../_shared";

export const rejectedVehiclesConnectionOnProviderPayloadSchema = z.object({
  uuid: z.uuid(),
  vin: z.string(),
  isEligible: z.boolean(),
  dataProvider: telemetryDataProviderSchema,
  reason: z.string(),
  companyUuid: z.uuid(),
});

export type RejectedVehiclesConnectionOnProviderPayload = z.infer<
  typeof rejectedVehiclesConnectionOnProviderPayloadSchema
>;
